import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const InputContainer = styled.div`
    width: 314px;
    background: #fff;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
`;

export const InputContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
`;

export const SearchInput = styled.input`
    flex: 1;
    border: none;
    outline: none;
    background: transparent;

    font-size: 14px;
    color: #5c5c5c;

    &::placeholder {
        color: #5c5c5c;
    }
`;

export const InputIcon = styled.img`
    width: 16px;
    height: 16px;
    object-fit: contain;
    cursor: pointer;
`;
